
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    props: {
        small: {
            required: false,
            default: false,
        },
        deliveryClosed: { type: Boolean, required: false },
        fullWidth: {
            required: false,
            default: false,
        },
        invert: {
            required: false,
            default: false,
        },
    },
    data() {
        return {
            selected: 'delivery',
        };
    },
    methods: {
        ...mapActions('order', ['changeDeliveryMethod']),
        ...mapMutations('modal', ['setModal']),
        ...mapMutations('order', ['setAddress', 'setDeliveryMethod']),
        setDeliveryMethodDelivery() {
            if (this.deliveryClosed) {
                return;
            }
            if (this.$route.name === 'checkout') {
                this.$emit('changedDelivery');
            }
            let address = null;
            if (!this.isDelivery) {
                if (this.loggedInUser) {
                    address = this.loggedInUser.addresses.filter(x => x.default);
                    if (address.length) {
                        this.setAddress(address[0]);
                        this.setDeliveryMethod('delivery');
                        // await this.$nextTick();
                    } else if (this.loggedInUser.addresses.length) {
                        this.setAddress(this.loggedInUser.addresses[0]);
                        this.setDeliveryMethod('delivery');
                    }
                }
            }
            if (!address || (Array.isArray(address) && !address.length) || this.$route.name === 'checkout') {
                this.changeDeliveryMethod({ method: 'delivery' });
            }
        },
        setPickup() {
            if (this.$route.name === 'checkout') {
                this.$emit('changedPickup');
            }
            this.changeDeliveryMethod({ method: 'pickup' });
        },
    },
    computed: {
        ...mapGetters('order', ['isDelivery', 'address']),
        ...mapGetters(['loggedInUser']),
        deliveryGreyed() {
            return this.$route.name === 'checkout' && this.deliveryClosed;
        },
    },
};
